import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import "./HomePage.css";

import Header from "../components/Header";
import Hero from "../components/Hero";
import BrandSection from "../components/BrandSection";
import WhoWeAre from "../components/WhoWeAre";
import WhyChooseUs from "../components/WhyChooseUs";
import Products from "./Products";
import OurServices from "../components/OurServices";
import Projects from "../components/Projects";
import ACGallery from "../components/ACGallery";
import ACVideoGallery from "../components/ACVideoGallery";
import Footer from "../components/Footer";
import FloatingActions from "../components/FloatingActions";

import logo from "../assets/logo.png";
import splash1 from "../assets/splash1.jpeg";

export default function HomePage() {
  const navigate = useNavigate();
  const [showSplash, setShowSplash] = useState(true);
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSplash(false);
      setShowPopup(true);
    }, 10000);

    return () => clearTimeout(timer);
  }, []);

  const handleCloseSplash = () => {
    setShowSplash(false);
    setShowPopup(true);
  };

  return (
    <div className="page-container">
      {/* ✅ SEO HEAD */}
      <Helmet>
        {/* Primary SEO */}
        <title>Best AC Service in Coimbatore | Sky Breeze AC Solutions</title>
        <meta
          name="description"
          content="Sky Breeze AC Solutions offers AC repair, installation, gas filling, and maintenance services in Coimbatore. Fast, affordable, and reliable AC service near you."
        />
        <link rel="canonical" href="https://skybreezeacsolutions.in/" />

        {/* Mobile + Indexing */}
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="robots" content="index, follow" />

        {/* Open Graph (Social Sharing) */}
        <meta property="og:title" content="Best AC Service in Coimbatore | Sky Breeze AC Solutions" />
        <meta property="og:description" content="Top AC repair, installation, and maintenance services in Coimbatore." />
        <meta property="og:image" content="https://skybreezeacsolutions.in/logo.png" />
        <meta property="og:url" content="https://skybreezeacsolutions.in/" />
        <meta property="og:type" content="website" />

        {/* Structured Data */}
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "HVACBusiness",
            "name": "Sky Breeze AC Solutions",
            "image": "https://skybreezeacsolutions.in/logo.png",
            "url": "https://skybreezeacsolutions.in/",
            "telephone": "+91-9384177714",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "22, 4th Cross, Ramalingam Colony, KK Pudur(Po)",
              "addressLocality": "Coimbatore",
              "addressRegion": "TN",
              "postalCode": "641038",
              "addressCountry": "IN"
            },
            "sameAs": [
              "https://www.facebook.com/profile.php?id=61587039728926",
              "https://www.instagram.com/skybreezeacsolutions2026/"
            ]
          }
          `}
        </script>
      </Helmet>

      {/* ✅ PAGE CONTENT */}
      <Header />
      <Hero navigate={navigate} />

      {/* ✅ SEO TEXT CONTENT */}
      

      <BrandSection />
      <WhoWeAre />
      <WhyChooseUs />
      <Products showHeader={false} showFooter={false} />
      <OurServices />
      <Projects showHeader={false} showFooter={false} />
      <ACGallery />
      <ACVideoGallery />
      <Footer />
      <FloatingActions whatsappNumber="917904659026" />

      {/* ✅ SPLASH */}
      {showSplash && (
        <>
          <div className="splash-background-overlay" onClick={handleCloseSplash} />
          <div className="splash-container">
            <button className="splash-close" onClick={handleCloseSplash}>X</button>
            <img
              src={splash1}
              alt="AC service and repair in Coimbatore"
              className="splash-image"
            />
          </div>
        </>
      )}

      {/* ✅ POPUP */}
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-box">
            <button className="popup-close" onClick={() => setShowPopup(false)}>X</button>

            <div className="popup-top">
              <h2>Select User Type</h2>
            </div>

            <div className="popup-main popup-column">
              <div className="popup-top-area">
                <img
                  src={logo}
                  alt="Sky Breeze AC Solutions logo - AC service in Coimbatore"
                  className="popup-logo"
                />
                <h1 className="popup-company">
                  Discover the best cooling solution designed for you in Coimbatore and enjoy comfortable, refreshing performance throughout every season.
                </h1>
              </div>

              <div className="popup-buttons">
                <button
                  className="popup-btn-fill"
                  onClick={() =>
                    navigate("/buttondetails", { state: { userType: "student" } })
                  }
                >
                  I Am a Student
                </button>

                <button
                  className="popup-btn-fill"
                  onClick={() =>
                    navigate("/buttondetails", { state: { userType: "customer" } })
                  }
                >
                  I Am a Customer
                </button>

                <button
                  className="popup-btn-fill"
                  onClick={() =>
                    navigate("/buttondetails", { state: { userType: "engineer" } })
                  }
                >
                  Architect <br /> Builder <br /> Dealer
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}